import config from './config';
import base from './base'
import request from "./request";

// 变量
const exceljs = require('exceljs');
const borderStyle = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' }
};
var listData = [];
var sum = null;

//普通导出，报表格式
export function exportExcel(self) {
    listData = [];
    sum = null;

    var search = base.copyJson(self.search);
    search.page = 1;
    search.export_flag = 1;
    search.limit = config.export_limit;
    base.showLoading('正在获取数据，请稍后 ...');
    getExcelData(self,search);
}

//获取数据
function getExcelData(self,search) {
    //处理数据
    request.sendPost(search.search_url,search,(success,data,error)=>{
        if(success){
            var last_page = data.last_page || -1;

            var tot_row = 0;
            if(last_page == -1){//无分页
                if(data.length == 0){
                    base.hideLoading();
                    base.alertErr(config.i18n.tc('search_nodata'));
                    return;
                }
                listData = data;
                tot_row = listData.length;
            }
            else{
                if(search.page == 1 && data.list.length == 0){
                    base.hideLoading();
                    base.alertErr(config.i18n.tc('search_nodata'));
                    return;
                }
                listData = listData.concat(data.list);
                tot_row = data.total.total;
            }

            base.showLoading('已获取 ' + listData.length + ' 条；共 ' + tot_row + ' 条');
            if(search.page < data.last_page){
                search.page = parseInt(search.page) + 1;
                getExcelData(self, search);
            }
            else{
                if(data.total && data.total.sum){
                    sum = data.total.sum;
                }
                base.showLoading('已全部获取，正在合并下载');
                buildExcel(self);
            }
        }
        else{
            base.hideLoading();
            base.alertErr(error.errmsg);
        }
    });
}

//构建
function buildExcel(self) {

    const workbook = new exceljs.Workbook();// 创建工作簿
    const ws = workbook.addWorksheet("Sheet1");

    // 表头
    var export_list_hearder = {};
    if(self.listHeaderHide){ //如果有隐藏功能
        Object.keys(self.listHeader).forEach(key =>{
            if(!self.listHeaderHide[key]){
                export_list_hearder[key] = self.listHeader[key];
            }
        });
    }
    else{
        export_list_hearder = self.listHeader;
    }
    var export_title = base.getRequest().fn || '下载';
    var search_time = '';
    if(self.search.date_fr && self.search.date_fr != ''){
        search_time = ' (' + self.search.date_fr + ' - ' + self.search.date_to + ')';
    }
    var curRow = ws.addRow([export_title + search_time]);
    curRow.height = 33;
    curRow.font = { bold: true };
    curRow.alignment = { horizontal: 'left', vertical: 'middle' };
    ws.getCell('A1').border = borderStyle;

    // 合并 A1 到 C1 的单元格
    mergeCells(ws,{
        start:{row:1,col:1},
        end:{row:1,col:Object.keys(export_list_hearder).length},
    });

    //标题
    var titles = [];
    Object.keys(export_list_hearder).forEach((key,index) =>{
        titles.push(export_list_hearder[key]);
        ws.getColumn(index + 1).width = 20;
    });
    if(self.data_key_name2){
        var old_cols = titles.length;
        Object.keys(self.listHeader2).forEach((key,index) =>{
            titles.push(self.listHeader2[key]);
            ws.getColumn(index + old_cols + 1).width = 20;
        });
    }
    curRow = ws.addRow(titles);
    curRow.height = 27;
    curRow.alignment = { vertical: 'middle' };
    curRow.eachCell((cell, colNumber) => {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D2F4F2' } };
        cell.border = borderStyle;
    });

    //内容
    if(self.data_key_name2){
        listData.forEach(row => {
            var col = [];
            Object.keys(export_list_hearder).forEach(key =>{
                col.push(row[key]);
            });

            var sub_length = row[self.data_key_name2].length;
            if(sub_length > 0){
                row[self.data_key_name2].forEach((sub_row,sub_index) => {
                    var sub_col = [];
                    Object.keys(self.listHeader2).forEach(sub_key =>{
                        sub_col.push(sub_row[sub_key]);
                    });

                    curRow = ws.addRow(col.concat(sub_col));
                    if(sub_index == (sub_length - 1)){ //最后一行时合并
                        curRow.eachCell((cell, colNumber) => {
                            cell.border = borderStyle;

                            if(cell.col <= col.length){
                                mergeCells(ws,{
                                    start:{row:curRow.number - (sub_length - 1),col:cell.col},
                                    end:{row:curRow.number,col:cell.col},
                                });
                            }
                        });
                    }
                    else{
                        curRow.eachCell((cell, colNumber) => {
                            cell.border = borderStyle;
                        });
                    }
                });
            }
            else{
                var sub_col = [];
                Object.keys(self.listHeader2).forEach(key =>{
                    sub_col.push('');
                });
                curRow = ws.addRow(col.concat(sub_col));
                curRow.eachCell((cell, colNumber) => {
                    cell.border = borderStyle;
                });
            }
        });
    }
    else{
        listData.forEach(row => {
            var col = [];
            Object.keys(export_list_hearder).forEach(key =>{
                col.push(row[key]);
            });

            curRow = ws.addRow(col);
            curRow.eachCell((cell, colNumber) => {
                cell.border = borderStyle;
            });
        });
    }

    //处理数行高
    ws.eachRow((row, rowNumber) => {
        if(rowNumber > 2){
            row.height = 27;
            row.alignment = { vertical: 'middle' };
        }
    });

    // 表尾
    if(sum){
        var footer = [];
        Object.keys(export_list_hearder).forEach((key,index) =>{
            if(index == 0){
                footer.push('合计');
            }
            else if(sum[key]){
                footer.push(sum[key]);
            }
            else{
                footer.push('');
            }
        });
        if(self.data_key_name2){
            Object.keys(self.listHeader2).forEach(key =>{
                footer.push('');
            });
        }
        curRow = ws.addRow(footer);
        curRow.height = 27;
        curRow.font = { bold: true, color: { argb: 'FF0000' } };
        curRow.alignment = { horizontal: 'center', vertical: 'middle' };
        curRow.eachCell((cell, colNumber) => {
            cell.border = borderStyle;
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D2F4F2' } };
        });
    }

    // 固定行和列
    if(self.excel_frow_num || self.excel_fcol_num){
        ws.views = [
            { state: 'frozen', xSplit: (self.excel_fcol_num || 0), ySplit: (self.excel_frow_num || 0) }
        ];
    }

    // 开启筛选
    ws.autoFilter = {
        from: 'A2',
        to: ws.getColumn(ws.columnCount).letter + '2'
    };

    workbook.xlsx.writeBuffer()
        .then(buffer => {
            // 创建 Blob 对象
            const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});

            // 创建下载链接
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = export_title + ".xlsx";
            a.click();

            // 清理 URL
            setTimeout(() => {
                window.URL.revokeObjectURL(url);
                a.remove();
                listData = [];
            }, 100);

            base.hideLoading();
        })
        .catch(err => {
            base.hideLoading();
            base.alertErr('Excel 下载失败');
        });
}

function mergeCells(sheet, range) {
    let startRow = range['start']['row']; // 合并开始行
    let endRow = range['end']['row']; // 合并结束行
    let startCell = range['start']['col']; // 合并开始列
    let endCell = range['end']['col']; // 合并结束列
    let alphabetMap = {
        1: 'A',
        2: 'B',
        3: 'C',
        4: 'D',
        5: 'E',
        6: 'F',
        7: 'G',
        8: 'H',
        9: 'I',
        10: 'J',
        11: 'K',
        12: 'L',
        13: 'M',
        14: 'N',
        15: 'O',
        16: 'P',
        17: 'Q',
        18: 'R',
        19: 'S',
        20: 'T',
        21: 'U',
        22: 'V',
        23: 'W',
        24: 'X',
        25: 'Y',
        26: 'Z'
    };
    sheet.mergeCells(`${alphabetMap[startCell]}${startRow}:${alphabetMap[endCell]}${endRow}`);
}

export default {
    exportExcel
}



// WEBPACK FOOTER //
// ./src/utils/excel.js